<template>
  <form-template
    :data="data"
    :blocks="blocks"
    :snackbar="snackbar"
    title="Youtube"
    @save="save"
  >
    <v-text-field
      v-model="override.content"
      label="Идентификатор видео"
      :rules="rules"
    ></v-text-field>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header> Справка </v-expansion-panel-header>
        <v-expansion-panel-content>
          <p>
            Идентификатор можно взять из адресной строки, сразу после
            <b>v=</b> и до символа <b>&</b> (или до конца, если его нет)
          </p>
          <p>
            Также идентификатор можно взять в ссылке для копирования в меню
            шеринга (кнопки "поделиться") под видео. Идентификатор будет после
            последнего слеша (<b>/</b>)
          </p>
          <img
            style="max-width: 100%"
            src="/assets/images/yt_tutorial.jpg"
            alt='Выберите пункт "вставить" в меню поста, скопируйте и вставьте сюда код для встраивания.'
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </form-template>
</template>

<script>
import formMixin from "./formMixin";
import FormTemplate from "./Template";

export default {
  name: "FormYoutube",
  components: { FormTemplate },
  mixins: [formMixin],
  data() {
    return {
      override: {
        content: this.data.content
      }
    };
  }
};
</script>
